import { GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, graphqlOperation } from 'aws-amplify';

const getAssessmentURLQuery = `query MyQuery($input: GetAssessmentURLInput!) {
  getAssessmentURL(input: $input)
  }`;

export const getAssessmentPdfUrlThunk = createAsyncThunk<string, string>(
  'assessment/getAssessmentPdfUrlThunk',
  async (assessmentId, thunkApi) => {
    try {
      const result = (await API.graphql(
        graphqlOperation(getAssessmentURLQuery, {
          input: { id: assessmentId },
        }),
      )) as GraphQLResult<{ getAssessmentURL: string }>;

      if (!result?.data) {
        return thunkApi.rejectWithValue({
          message: 'assessment pdf url not found',
        });
      }
      return result.data.getAssessmentURL;
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error,
      });
    }
  },
);
